import { Button } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { Link as RRLink, useHistory } from 'react-router-dom';
import ComingPic from './../../assets/ComingSoon.png';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'block',
      textAlign: 'center'
    },
    picture: {
      marginTop: theme.spacing(10),
      width: 480,
      [theme.breakpoints.down('xs')]: {
        width: 280
      }
    },
    credit: {
      textDecoration: 'none',
      color: theme.palette.text.secondary,
      fontSize: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        fontSize: theme.spacing(0.6)
      }
    },
    text: {
      padding: theme.spacing(0, 4)
    },
    button: {
      margin: theme.spacing(1),
      marginTop: 0
    }
  })
);

export default function Search() {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  return (
    <div className={classes.root}>
      <img className={classes.picture} src={ComingPic} alt={t('search.alt.comingSoon') as string} />
      <div>
        <a className={classes.credit} href="https://www.freepik.com/vectors">
{t('common.freepikCredit')}
        </a>
      </div>
      <h2 className={classes.text}>{t('search.text.comingSoon')}</h2>
      <Button
        className={classes.button}
        color="primary"
        size="large"
        onClick={() => {
          history.goBack();
        }}
      >
        {t('search.buttons.back')}
      </Button>
      <Button
        className={classes.button}
        to="/"
        component={RRLink}
        variant="contained"
        color="primary"
        size="large"
      >
        {t('search.buttons.home')}
      </Button>
    </div>
  );
}
